import {
  ArcElement,
  BarController,
  BarElement,
  BubbleController,
  CategoryScale,
  Chart as ChartJS,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  LogarithmicScale,
  PointElement,
  ScatterController,
  Tooltip,
} from 'chart.js';

/**
 * ТЗ 0103 — однократная регистрация всего, что нужно общим графикам.
 *
 * Типизированные `<Bar>/<Line>` регистрируют свои контроллеры сами, общий
 * `<Chart type=…>` — нет: смешанный график, пузырьки и scatter без явной
 * регистрации падают с «"bubble" is not a registered controller». Без
 * `TimeScale` — ему нужен адаптер дат, а оси здесь категориальные.
 *
 * Повторный вызов ничего не делает (chart.js и сам терпит повтор, но так
 * дешевле и честнее в профайлере).
 */
let registered = false;

export const registerCharts = (): void => {
  if (registered) return;
  ChartJS.register(
    ArcElement,
    BarController,
    BarElement,
    BubbleController,
    CategoryScale,
    DoughnutController,
    Filler,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    LogarithmicScale,
    PointElement,
    ScatterController,
    Tooltip,
  );
  registered = true;
};
